import styled from "styled-components";
import { useHistory } from "react-router-dom";

import Payback from "components/containers/commerce/payback/Payback";

import TitleHeader from "components/presenters/header/TitleHeader";

export default function CommnercePaybackLayout() {
  const history = useHistory();
  return (
    <Wrapper>
      <HeaderBlock>
        <TitleHeader title={"환급내역"} onBackBtn={() => history.goBack()} />
      </HeaderBlock>
      <Content>
        <Payback />
      </Content>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
`;

const HeaderBlock = styled.div`
  flex: 0 1 auto;
  min-height: calc(100vw * (59.68 / 375));
  height: calc(100vw * (60 / 375));
`;

const Content = styled.div`
  flex: 1 1 auto;
  height: 100%;
  padding: calc(100vw * (17 / 375));
  padding-top: calc(100vw * (15 / 375));
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  /* padding-bottom: calc(100vw * (50 / 375)); */
`;
